/**
 * Requires
 */

import $ from 'jquery'

/**
 * Initialisation
 */

export function initialise() {
  $(document).on('click', '[data-calendar-navigate]', event => {
    const direction = $(event.currentTarget).attr('data-calendar-navigate')
    const calendar = $(event.currentTarget).parents('[data-calendar]')[0]
    calendar.hidden = true
    if (direction === 'next') {
      calendar.nextElementSibling.hidden = false
    } else {
      calendar.previousElementSibling.hidden = false
    }
  })

  $(document).on('click', '[data-calendar-navigate-month]', event => {
    const month = $(event.currentTarget).attr('data-calendar-navigate-month')
    const calendar = $(event.currentTarget).parents('[data-calendar]')[0]
    const nextCalendar = $(calendar).siblings(`[data-calendar-month="${month}"]`)[0]
    if (calendar && nextCalendar) {
      calendar.hidden = true
      nextCalendar.hidden = false
    }
  })

  $(document).on('click', '.active-cell', event => {
    const calendar = $(event.currentTarget).parents('[data-calendar]')[0]
    const color = $(calendar).attr('data-calendar-color')
    const colorClasses = ['color-' + color + '-alternative', 'background-' + color]
    $('.active-cell').removeClass('selected-cell')
    $('.active-cell .calendar-date').removeClass(colorClasses)
    $(event.currentTarget)
      .addClass('selected-cell')
      .find('.calendar-date')
      .first()
      .addClass(colorClasses)
    const cellDate = $(event.currentTarget).attr('data-calendar-cell-date')
    $('[data-session-info-date]').addClass('hide')
    if (cellDate) {
      $('[data-session-info-date="' + cellDate + '"]').removeClass('hide')
    }
  })

  fixActiveCell()

  $(document).on('ajax.replace', () => fixActiveCell())
}

function fixActiveCell() {
  $('.active-cell + .cell')
    .prev()
    .addClass('active-cell-last')
}
